<div class="ks-skeleton-group" role="status" [attr.aria-label]="label()" aria-busy="true">
  @for (item of items(); track item) {
    <span
      class="ks-skeleton"
      [class.ks-skeleton--circle]="shape() === 'circle'"
      [class.ks-skeleton--block]="shape() === 'block'"
      [style.width]="width()"
      [style.height]="resolvedHeight()"
      aria-hidden="true"></span>
  }
</div>
